import React from 'react'
import About from '../../components/Aboutpage'
import Email from '../../components/Email'
import Accordion from '../../components/Accordion'

function Abouts() {
    return (
        <>
            <About />
            <Accordion />
            <Email />
        </>
    )
}

export default Abouts
